import { PRESET_FEATURES } from "@follaw-fr/utils/features";
import { useFeaturesStores } from "./useFeaturesStores";

export function useApplyFeaturesFilters() {
  const { featuresStores } = useFeaturesStores();

  const applyFeaturesFilters = (filters: { [key: string]: any }) => {
    // Apply filters in features
    // 1) Get only features with filters in the dashboard filter
    const featureFilters: { [key: string]: any } = {};
    Object.values(PRESET_FEATURES).forEach((feature) => {
      if (filters[feature]) {
        featureFilters[feature] = Object.fromEntries(
          // Keep only non null filters
          // The [,v] syntax is because the entries are needed to recompose the object after filtering but we don't need to use the key in the callback
          Object.entries({
            ...filters[feature],
          }).filter(([, v]) => v !== null)
        );
      }
    });

    // 2) for each feature, reset the store
    Object.keys(featuresStores).forEach((feature) => {
      featuresStores[feature].resetFilters();
    });

    // 3) for each feature with filters, set it in the corresponding store
    Object.entries(featureFilters).forEach(([feature, activeFilters]) => {
      featuresStores[feature].selectedFilters = {
        ...featuresStores[feature].selectedFilters,
        ...activeFilters,
      };
    });
  };

  return {
    applyFeaturesFilters,
  };
}
